import React from "react";
import { useTheme } from "@mui/material";

const AddressEditSvg = () => {
  const theme = useTheme();
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.22685 9.16536H10.9883L16.1886 3.9987L14.4272 2.2487L9.22685 7.41536V9.16536ZM16.7758 3.41536L17.3629 2.83203C17.5307 2.66536 17.6145 2.47092 17.6145 2.2487C17.6145 2.02648 17.5307 1.83203 17.3629 1.66536L16.7758 1.08203C16.608 0.915365 16.4123 0.832031 16.1886 0.832031C15.9649 0.832031 15.7692 0.915365 15.6015 1.08203L15.0143 1.66536L16.7758 3.41536ZM10.0656 18.332C7.81492 16.4293 6.13403 14.6618 5.02294 13.0295C3.91129 11.3979 3.35547 9.88759 3.35547 8.4987C3.35547 6.41536 4.03012 4.75564 5.37942 3.51953C6.72816 2.28342 8.29022 1.66536 10.0656 1.66536C10.4431 1.66536 10.8172 1.69648 11.1879 1.7587C11.5581 1.82148 11.9179 1.90842 12.2674 2.01953L10.9044 3.39453C10.7646 3.36675 10.6281 3.34925 10.4951 3.34203C10.3625 3.33536 10.2194 3.33203 10.0656 3.33203C8.65369 3.33203 7.4618 3.81453 6.48995 4.77953C5.51865 5.74509 5.033 6.98481 5.033 8.4987C5.033 9.48481 5.4454 10.6131 6.27019 11.8837C7.09498 13.1548 8.36012 14.5681 10.0656 16.1237C11.7711 14.5681 13.0363 13.1548 13.861 11.8837C14.6858 10.6131 15.0982 9.48481 15.0982 8.4987C15.0982 8.33203 15.0912 8.1687 15.0773 8.0087C15.0633 7.84925 15.0423 7.69314 15.0143 7.54036L16.3983 6.16536C16.5241 6.52648 16.6186 6.90148 16.6818 7.29036C16.7444 7.67925 16.7758 8.08203 16.7758 8.4987C16.7758 9.88759 16.2202 11.3979 15.1091 13.0295C13.9975 14.6618 12.3163 16.4293 10.0656 18.332Z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};

export default AddressEditSvg;
